import React from 'react';
import './index.css';
import ravenFull from './raven_full.png';

const Home: React.FC = () => {
  return (
    <div className='Home'>
      <h1>Welcome to the Raven Initiative</h1>
      <div className='Content-With-Image'>
        <img alt="Raven Logo" src={ravenFull}/>
      </div>
        <p>
          The Raven Initiative was established by a group of experienced clinicians, in order to provide trauma informed care though counselling and education services.
    <br/><br/>
    We are an online practice operating remotely via telehealth allowing clients to attend sessions via Skype, zoom or phone. Occasionally services are provided face to face in corporate settings.
        </p>
    <p>
  Our philosophy is based on the premise that clients should be informed and empowered throughout their journey. While every member of our team brings a degree of expertise to the process, we also maintain the belief that the client is the expert in their own life.
    </p>

    <p>
  As well as counselling and training, we provide consultancy services to various organisations based on our skills and experience in mental health and trauma.
    </p>

    <p>
  We chose the Raven as our symbol as it represents renewal, rebirth, recovery and healing. The Raven is recognized by many cultures as a companion through difficult journeys.
    </p>
    </div>
  )
}

export default Home;
